// extracted by mini-css-extract-plugin
module.exports = {"container":"Agiles_container__QC22e","contenido":"Agiles_contenido__sAS0U","features":"Agiles_features__1QO33"};